import React from 'react';
import styles from './styles.module.scss';

const TableDesktopHeader = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tableCell
  }, /*#__PURE__*/React.createElement("span", null, "Time")), /*#__PURE__*/React.createElement("div", {
    className: styles.tableCell
  }, /*#__PURE__*/React.createElement("span", null, "Price")), /*#__PURE__*/React.createElement("div", {
    className: styles.tableCell
  }, /*#__PURE__*/React.createElement("span", null, "Seller")), /*#__PURE__*/React.createElement("div", {
    className: styles.tableCell
  }, /*#__PURE__*/React.createElement("span", null, "Buyer")));
};

export default TableDesktopHeader;